// extracted by mini-css-extract-plugin
export default {"root":"Confirm_root__Njme6","wrapper":"Confirm_wrapper__zNm3N"};